import { useStrategies } from '../../../hooks/useStrategies';

export const useActiveStrategies = () => useStrategies('active');
